export default {
  title: `The following users currently get auto emails related to {clientFullName}.`,
  note: `<b>Note:</b> In order for a Practice Admin to receive auto emails about {clientFullName}, the Practice Admin must be granted appropriate permission by the adviser in 'My Support', and they must also be following {clientFullName}.`,
  noAdviserAssigned: `Client does not receive auto emails (no adviser assigned).`,
};
